"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function TickInFilledCircleIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "m12,23.161C5.845,23.161.839,18.154.839,12S5.845.839,12,.839s11.161,5.007,11.161,11.161-5.007,11.161-11.161,11.161Z" }),
        react_1.default.createElement("path", { fill: "#fff", d: "m10.282,16.369c-.218,0-.436-.083-.601-.249l-3.604-3.604,1.201-1.201,3.003,3.002,6.438-6.438,1.201,1.201-7.039,7.039c-.165.166-.383.249-.601.249Z" })));
}
exports.default = TickInFilledCircleIcon;
